// extracted by mini-css-extract-plugin
export var buttons = "_bq-0";
export var buttonsActive = "_bq-h";
export var cancelConfirm = "_bq-1";
export var closeButton = "_bq-2";
export var column = "_bq-3";
export var container = "_bq-4";
export var detailHeader = "_bq-6";
export var detailTitle = "_bq-7";
export var detailsContent = "_bq-5";
export var header = "_bq-8";
export var headerWithClose = "_bq-9";
export var icon = "_bq-a";
export var infoIcon = "_bq-c";
export var informationContainer = "_bq-b";
export var sideDrawer = "_bq-d";
export var sideDrawerOpen = "_bq-e";
export var stickyFooter = "_bq-f";
export var typeOption = "_bq-g";